import { createAuthClient } from "better-auth/client";
import { twoFactorClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "/api",
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect({ twoFactorMethods }) {
        window.location.href = "/2fa";
      },
    }),
  ],
});

export const { signIn, signOut, signUp, useSession, org } = authClient;